"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorageLib {
    constructor() {
        this.prefix = '@secure.j.';
        this.getItem = (name) => {
            try {
                let object = localStorage.getItem(`${this.prefix}${name}`);
                if (object) {
                    const decryptedText = window.atob(object);
                    const decryptedObject = JSON.parse(decryptedText);
                    return decryptedObject;
                }
                return {};
            }
            catch (err) {
                this.removeItem(name);
                console.error(err);
                return '';
            }
        };
        this.setItem = (name, object) => {
            let res = 0;
            try {
                let plainObject = JSON.stringify(object);
                const res = window.btoa(plainObject);
                localStorage.setItem(`${this.prefix}${name}`, res);
            }
            catch (err) {
                console.error(err);
                res = 1;
            }
        };
        this.removeItem = (name) => {
            localStorage.removeItem(`${this.prefix}${name}`);
        };
    }
}
exports.default = LocalStorageLib;
//# sourceMappingURL=index.js.map